/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_GRAPH_DATA, GRAPH_DATA_RECEIVED } = constants.analysisConstants;

export default {
    REQUEST_GRAPH_DATA,
    GRAPH_DATA_RECEIVED,

  requestGraphData: payload => ({
    type: REQUEST_GRAPH_DATA,
    payload
  }),
  graphDataReceived: () => ({
    type: GRAPH_DATA_RECEIVED
  }),
};
